<template>
    <div class="skeleton-bless skeleton-el">
        <p class="block1 block"></p>
        <div>
            <p class="block2 block"></p>
            <div class="block3">
                <p class="block"></p>
                <p class="block"></p>
            </div>
            <p class="block4 block"></p>
            <p class="block2 block"></p>
            <ul class="block5">
                <li class="block"></li>
                <li class="block"></li>
                <li class="block"></li>
                <li class="block"></li>
            </ul>
            <p class="block7 block"></p>
            <ul class="block5">
                <li class="block"></li>
                <li class="block"></li>
                <li class="block"></li>
                <li class="block"></li>
            </ul>
        </div>
        <div class="block6">
            <div>
                <div class="block"></div>
                <div class="block"></div>
            </div>
            <div class="block"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'SkeletonBless',
};
</script>
<style lang="scss" scoped>
.skeleton-bless {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    min-height: 100vh;
    background: #fff;
    .block {
        background: #F0F0F0;
    }
    & > div:nth-child(2) {
        margin: 0 50px;
    }

    .block1 {
        height: 200px;
    }
    .block2, .block7 {
        width: 136px;
        height: 36px;
        border-radius: 18px;
        margin: 48px 0 26px;
    }
    .block3 {
        @include SpaceBetween();
        div {
            width: 320px;
            height: 48px;
            border-radius: 24px;
        }
    }
    .block4 {
        height: 202px;
        margin: 33px 0 94px;
    }
    .block5 {
        @include SpaceBetween();
        li {
            width: 150px;
            height: 150px;
        }
    }
    .block7 {
        margin-top: 140px;
    }
    .block6 {
        width: 100vw;
        height: 130px;
        position: fixed;
        bottom: 0;
        left: 0;
        background: #fff;
        @include SpaceBetween();
        align-items: center;
        padding: 0 30px 0 40px;
        & > div {
            &:first-child {
                @include SpaceBetween();
                div {
                    width: 100px;
                    height: 36px;
                    border-radius: 18px;
                    margin-right: 29px;
                }
            }
            &:last-child {
                width: 274px;
                height: 76px;
                border-radius: 38px;
            }
        }
    }
}
</style>
